"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_2 = require("@fluentui/react");
var react_redux_1 = require("react-redux");
var reducers_1 = require("../../reducers");
var CustomLabel_1 = require("./CustomLabel");
require("./CustomSlider.scss");
var connector = react_redux_1.connect(reducers_1.ComponentEtaMapStateToProps);
var CustomSlider = function (props) {
    var currentLang = props.currentLang, className = props.className, readOnly = props.readOnly, toolTip = props.toolTip, toolTipLink = props.toolTipLink, toolTipLinkOnClick = props.toolTipLinkOnClick, containerClassName = props.containerClassName, label = props.label;
    var useClassName = clsx_1.default(className, readOnly ? 'eta-cSliderReadOnly' : '', currentLang.isRtl ? 'rtlFlag' : 'ltrFlag');
    return (react_1.default.createElement("div", { className: clsx_1.default('eta-vertialFlexDiv', containerClassName) },
        label && (react_1.default.createElement(CustomLabel_1.Label, { toolTip: toolTip, toolTipLink: toolTipLink, toolTipLinkOnClick: toolTipLinkOnClick }, label)),
        react_1.default.createElement(react_2.Slider, __assign({}, props, { className: useClassName, label: undefined }))));
};
exports.default = connector(CustomSlider);
//# sourceMappingURL=CustomSlider.js.map